module.exports = __webpack_public_path__ + "img/1542891074.ccce7af7.jpg";